import { render, staticRenderFns } from "./CommentAndCopy.vue?vue&type=template&id=2b4a6a32&"
import script from "./CommentAndCopy.vue?vue&type=script&lang=js&"
export * from "./CommentAndCopy.vue?vue&type=script&lang=js&"
import style0 from "./CommentAndCopy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports